<template>
  <svg id="straws_comparison" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.09 33.485H28.58C29.84 33.485 30.875 32.525 31.025 31.295L33.5 6.575H26V0.5H23.045V6.575H15.59L16.04 10.085C18.605 10.79 21.005 12.065 22.445 13.475C24.605 15.605 26.09 17.81 26.09 21.41V33.485ZM0.5 31.985V30.5H23.045V31.985C23.045 32.81 22.37 33.485 21.53 33.485H2.015C1.175 33.485 0.5 32.81 0.5 31.985ZM23.045 21.485C23.045 9.485 0.5 9.485 0.5 21.485H23.045ZM0.53 24.5H23.03V27.5H0.53V24.5Z"
      fill="currentColor"
    />
  </svg>
</template>
